import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListOauth2ScopesPageComponent } from './list-oauth2-scopes-page/list-oauth2-scopes-page.component';
import { CreateOauth2ScopeComponent } from './create-oauth2-scope-page/create-oauth2-scope.component';
import { EditOauth2ScopeComponent } from './edit-oauth2-scope-page/edit-oauth2-scope.component';

const routes: Routes = [
  {
    path: '',
    component: ListOauth2ScopesPageComponent,
    children: [],
  },
  {
    path: 'create',
    component: CreateOauth2ScopeComponent,
  },
  {
    path: 'edit/:id',
    component: EditOauth2ScopeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RoutingModule {}
